import { render, staticRenderFns } from "./Promov2.vue?vue&type=template&id=7a4e43b2&scoped=true"
import script from "./Promov2.vue?vue&type=script&lang=js"
export * from "./Promov2.vue?vue&type=script&lang=js"
import style0 from "./Promov2.vue?vue&type=style&index=0&id=7a4e43b2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4e43b2",
  null
  
)

export default component.exports